import { render, staticRenderFns } from "./RightContactUs.vue?vue&type=template&id=bf4243f2&scoped=true"
import script from "./RightContactUs.vue?vue&type=script&lang=js"
export * from "./RightContactUs.vue?vue&type=script&lang=js"
import style0 from "./RightContactUs.vue?vue&type=style&index=0&id=bf4243f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4243f2",
  null
  
)

export default component.exports